import { Card, Group, Stack, Text } from '@mantine/core'
import { RecentTransferResponse } from '../../../data/hostDashboard.service'
import { COLORS } from '../../../utils/constants'
import { convertServerDateToLocal } from '../../../utils/dateUtils'
import { formatNumber } from '../../../utils/displayUtils'

type RecentPayoutCardProps = {
  transfer: RecentTransferResponse
}

const RecentPayoutCard = ({ transfer }: RecentPayoutCardProps) => {
  return (
    <Card withBorder radius='md' p='md'>
      <Stack gap='xs'>
        <Group justify='space-between' mb='xs'>
          <Text size='sm'>
            {convertServerDateToLocal(
              new Date(transfer.date),
            )?.toLocaleDateString()}
          </Text>
          <Text fw={600} c={COLORS.LightGreen}>
            ${formatNumber(transfer.amount)}
          </Text>
        </Group>
        <Group justify='space-between'>
          <Text size='sm' c='dimmed'>
            Advertiser
          </Text>
          <Text size='sm'>{transfer.advertiserOrganizationName}</Text>
        </Group>
        <Group justify='space-between'>
          <Text size='sm' c='dimmed'>
            Location
          </Text>
          <Text size='sm'>{transfer.locationName}</Text>
        </Group>
        <Group justify='space-between'>
          <Text size='sm' c='dimmed'>
            Device
          </Text>
          <Text size='sm'>{transfer.deviceName}</Text>
        </Group>
        <Group justify='space-between'>
          <Text size='sm' c='dimmed'>
            Ad Name
          </Text>
          <Text size='sm'>{transfer.adName}</Text>
        </Group>
      </Stack>
    </Card>
  )
}

export default RecentPayoutCard
